import React from "react";
import { object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import Headline from "../../atoms/Headline";
import { staticTexts } from "../../utils/Translate";
import NavbarSearch from "../../layouts/header/NavbarSearch";
import FourIcon from "../../atoms/icons/FourIcon";
import NotFoundIcon from "../../atoms/icons/NotFoundIcon";

import "./not-found.m.css";

const NotFoundPageBase = ({ publisherAttributes }) => (
  <div styleName="wrapper">
    <div styleName="status">
      <FourIcon />
      <NotFoundIcon />
      <FourIcon />
    </div>
    <Headline text={staticTexts(publisherAttributes.lang).noResultsFound} headerLevel={1} headlineType={19} />
    <p styleName="no-results-breif">{staticTexts(publisherAttributes.lang).noResultsBreif}</p>
    <NavbarSearch publisherAttributes={publisherAttributes} />
    <div styleName={`cover-button ${publisherAttributes.lang}-cover`}>
      <Link href="/">{staticTexts(publisherAttributes.lang).cover}</Link>
    </div>
  </div>
);

NotFoundPageBase.propTypes = {
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export const NotFoundPage = connect(mapStateToProps, null)(NotFoundPageBase);
